import { ALL_TRAFFIC, LIVE_TRAFFIC, VOD_TRAFFIC } from './constants';

export const filterColors = [
  '#0d36a1', // Midnight
  '#9138a7', // Violet
  '#FFA500', // Orange
  '#0dba97', // Seafoam
  '#76c0d7', // Light Blue
  '#bd10e0', // Magenta
  '#f63f2c', // Bright Red
  '#46b04a', // Green
  '#2778c0', // Aqua
  '#cc3a74', // Dark Pink
  '#9a010c', // Blood
  '#88c340', // Lime Green
  '#007b88', // Teal
  '#6486da', // French Blue
  '#ce6940', // Rouge
  '#e25baa', // Pink
  '#4455c6', // Dark Blue
  '#9777ed', // Lavender
  '#ff9292', // Salmon
  '#6a8e3b', // Leaf Green
];

export const specialFilterColors = new Map([
  [ALL_TRAFFIC, '#0f93f5'], // Sky Blue
  [LIVE_TRAFFIC, '#6634b9'], // Purple
  [VOD_TRAFFIC, '#ff6347'], // Poppy
]);
